import React, { useContext, FormEvent } from 'react';
import { Box } from '@components';
import { Button, Form, Input, Icon, Checkbox, message } from 'antd';
import { AuthContext } from 'auth/context';
import { FormComponentProps } from 'antd/lib/form';
import './LoginForm.less';
import { environment } from 'environments/environment';

const LoginForm: React.FC<FormComponentProps> = ({ form }) => {
  const { isAuthenticating, login } = useContext(AuthContext);
  const { getFieldDecorator } = form;

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    form.validateFields((err, { email, password, remember }) => {
      if (!err) {
        login(email, password, remember).then(({ error }) => {
          if (error) {
            message.error('Incorrect email or password');
          }
        });
      }
    });
  };

  const ssoLogin = () => {
    window.location.href = `${environment.apiUrl}accounts/login/`;
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        content={
          <Form onSubmit={handleSubmit} className="LoginForm-form">
            <Form.Item>
              {getFieldDecorator('email', {
                rules: [{ required: true, message: 'Please input your email!' }]
              })(
                <Input
                  type="email"
                  prefix={
                    <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />
                  }
                  placeholder="Email"
                />
              )}
            </Form.Item>
            <Form.Item className="LoginForm-nomargin">
              {getFieldDecorator('password', {
                rules: [
                  { required: true, message: 'Please input your password!' }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />
                  }
                  type="password"
                  placeholder="Password"
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true
              })(<Checkbox>Remember me</Checkbox>)}
            </Form.Item>
            <Form.Item>
              <Button
                loading={isAuthenticating}
                type="primary"
                htmlType="submit"
                className="LoginForm-btn"
              >
                Log in
              </Button>
              <Button
                htmlType="button"
                onClick={() => ssoLogin()}
                className="LoginForm-btn btn-secondary"
              >
                SSO Log in
              </Button>
            </Form.Item>
          </Form>
        }
      />
    </div>
  );
};

export default Form.create()(LoginForm);
